import type { Context } from "@opentelemetry/api";
import type { ReadableSpan, Span as SDKSpan, SpanProcessor } from "@opentelemetry/sdk-trace-base";

/**
 * FilteringSpanProcessor forwards span lifecycle events to an inner processor
 * only when the provided predicate returns true for the span.
 */
export class FilteringSpanProcessor implements SpanProcessor {
  private readonly inner: SpanProcessor;
  private readonly include: (span: SDKSpan | ReadableSpan) => boolean;

  constructor(inner: SpanProcessor, include: (span: SDKSpan | ReadableSpan) => boolean) {
    this.inner = inner;
    this.include = include;
  }

  onStart(span: SDKSpan, context: Context): void {
    if (this.include(span)) {
      this.inner.onStart(span, context);
    }
  }

  onEnd(span: ReadableSpan): void {
    if (this.include(span)) {
      this.inner.onEnd(span);
    }
  }

  forceFlush(): Promise<void> {
    return this.inner.forceFlush();
  }

  shutdown(): Promise<void> {
    return this.inner.shutdown();
  }
}
